import { render, staticRenderFns } from "./bm.vue?vue&type=template&id=e4d678f4&scoped=true"
import script from "./bm.vue?vue&type=script&lang=js"
export * from "./bm.vue?vue&type=script&lang=js"
import style0 from "./bm.vue?vue&type=style&index=0&id=e4d678f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4d678f4",
  null
  
)

export default component.exports